/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

/**
 * Internal dependencies
 */
import AppSideBar from './AppSideBar';
import useData, { DRAWER_WIDTH } from './useData';

function SideBar(): React.ReactElement {
  /* Global & Local State */
  const { isGlobalSidebarOpen, toggleDrawer } = useData();

  /* Main */
  return (
    <Box sx={{ height: '100%' }}>
      <Box
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: { xs: 1, sm: 0 }
        }}
      >
        <Drawer
          variant="temporary"
          open={isGlobalSidebarOpen}
          onClose={toggleDrawer}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            '& > .MuiPaper-root': {
              width: `${DRAWER_WIDTH}px`
            }
          }}
        >
          <AppSideBar />
        </Drawer>
        <Drawer
          variant="persistent"
          sx={{
            '& > .MuiPaper-root': {
              width: `${DRAWER_WIDTH}px`
            }
          }}
          open
        >
          <AppSideBar />
        </Drawer>
      </Box>
    </Box>
  );
}

export default memo(SideBar);
